/**
 * TR sayı biçimini ayrıştır: "12.500" → 12500 · "1.234,56" → 1234.56 · "12,5" → 12.5.
 * Binlik ayraç (.) ve ondalık (,) doğru işlenir. (StockDashboardDrawers/ShipmentDetailDrawer
 * içindeki yerel kopyalarla aynı davranış; tek doğruluk kaynağı.)
 */
export function parseTrNumber(raw: string): number {
  const s = raw.trim();
  if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) return Number(s.replace(/\./g, "").replace(",", "."));
  if (s.includes(",")) return Number(s.replace(/\./g, "").replace(",", "."));
  return Number(s);
}
